export const evalInContext = (
    code: string,
    require: (module: string) => any,
    exports: Record<string, any>,
): (() => any) =>
    // eslint-disable-next-line no-new-func
    new Function('require', 'exports', code).bind(null, require, exports);
